module.exports = __webpack_public_path__ + "media/images/cardboard-img-06-8ff583fcb741a939ba699f79f29edb0a.jpg";